// extracted by mini-css-extract-plugin
export var closeButton = "_8x-0";